<div class="page-content-wrapper">
    <app-sidebar-layout [showMenuToggle]="true">
        <section>
            <div class="table-header">
                <div class="card-main-title">
                    <app-tab-main [links]="tabs"></app-tab-main>
                </div>
                <div class="table-actions">
                    <div class="search-input-div search-input-container">
                        <div class="input-group">
                            <button type="submit" class="input-group-addon">
                                <label for="search" class="label-icon">
                                    <i class="material-icons mb-0"
                                        >search</i
                                    ></label
                                >
                            </button>
                            <div class="input-field">
                                <input
                                    type="search"
                                    id="search"
                                    #searchInputField
                                    class="search-input mb-0"
                                    placeholder="{{
                                        'Search Location Groups' | translate
                                    }}"
                                    (input)="
                                        applyFilter(searchInputField.value)
                                    "
                                />
                            </div>
                        </div>
                    </div>
                    <div class="create-entity">
                        <button
                            type="button"
                            class="btn"
                            *objectHasPermission="
                                permissionObject;
                                action: GridPermissions.Create
                            "
                            (click)="openLocationGroupDialog()"
                        >
                            <span>{{
                                "Create Location Group" | translate
                            }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="white-box">
                <div class="card-inner-main-div">
                    <div class="tableColStyle without-borders-table">
                        <div class="table-responsive">
                            <table
                                mat-table
                                [dataSource]="dataSource"
                                multiTemplateDataRows
                                matSort
                                matSortDisableClear
                                matSortActive="name"
                                matSortDirection="asc"
                                class="mat-elevation-z8"
                            >
                                <ng-container matColumnDef="name">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef
                                        mat-sort-header
                                    >
                                        {{ "Name" | translate }}
                                    </th>
                                    <td mat-cell *matCellDef="let group">
                                        <button
                                            mat-icon-button
                                            (click)="toggleRow(group)"
                                        >
                                            <mat-icon class="expandable-icon">{{
                                                isExpanded(group)
                                                    ? "expand_less"
                                                    : "expand_more"
                                            }}</mat-icon>
                                        </button>
                                        {{ group.name }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="actions">
                                    <th
                                        mat-header-cell
                                        *matHeaderCellDef
                                        class="w-25"
                                    >
                                        {{ "Actions" | translate }}
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let group"
                                        class="d-flex"
                                    >
                                        <button
                                            class="btn btn-submit"
                                            *objectHasPermission="
                                                permissionObject;
                                                action: GridPermissions.Update
                                            "
                                            title="{{ 'Edit' | translate }}"
                                            (click)="
                                                openLocationGroupDialog(
                                                    group.id
                                                )
                                            "
                                        >
                                            <mat-icon>edit</mat-icon>
                                            {{ "Edit" | translate }}
                                        </button>
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="expandedDetail">
                                    <td
                                        mat-cell
                                        *matCellDef="let group"
                                        [attr.colspan]="displayedColumns.length"
                                    >
                                        <div
                                            class="element-detail inner-table"
                                            [@detailExpand]="
                                                isExpanded(group)
                                                    ? 'expanded'
                                                    : 'collapsed'
                                            "
                                        >
                                            <table
                                                mat-table
                                                [dataSource]="
                                                    expandLocationGroup(
                                                        group.id
                                                    )
                                                "
                                            >
                                                <ng-container
                                                    matColumnDef="name"
                                                >
                                                    <th
                                                        mat-header-cell
                                                        *matHeaderCellDef
                                                    >
                                                        {{
                                                            "Location Name"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <td
                                                        mat-cell
                                                        *matCellDef="
                                                            let location
                                                        "
                                                    >
                                                        {{ location.name }}
                                                    </td>
                                                </ng-container>

                                                <ng-container
                                                    matColumnDef="action"
                                                >
                                                    <th
                                                        class="action-column"
                                                        mat-header-cell
                                                        *matHeaderCellDef
                                                    >
                                                        {{
                                                            "Actions"
                                                                | translate
                                                        }}
                                                    </th>
                                                    <td
                                                        mat-cell
                                                        *matCellDef="
                                                            let location
                                                        "
                                                    >
                                                        <span
                                                            *objectHasPermission="
                                                                permissionObject;
                                                                action: GridPermissions.Update
                                                            "
                                                        >
                                                            <mat-icon
                                                                class="cursor-pointer"
                                                                title="{{
                                                                    'Edit'
                                                                        | translate
                                                                }}"
                                                                (click)="
                                                                    openLocationDialog(
                                                                        location.id,
                                                                        group.id
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="fas fa-edit action-icon"
                                                                ></i>
                                                            </mat-icon>
                                                        </span>
                                                        <span
                                                            *objectHasPermission="
                                                                permissionObject;
                                                                action: GridPermissions.Delete
                                                            "
                                                        >
                                                            <mat-icon
                                                                class="cursor-pointer"
                                                                title="{{
                                                                    'Delete'
                                                                        | translate
                                                                }}"
                                                                (click)="
                                                                    openLocationDeleteDialog(
                                                                        location
                                                                    )
                                                                "
                                                            >
                                                                <i
                                                                    class="fas fa-trash ml-2 action-icon"
                                                                ></i>
                                                            </mat-icon>
                                                        </span>
                                                    </td>
                                                </ng-container>

                                                <tr
                                                    mat-header-row
                                                    *matHeaderRowDef="[
                                                        'name',
                                                        'action',
                                                    ]"
                                                ></tr>
                                                <tr
                                                    mat-row
                                                    *matRowDef="
                                                        let location;
                                                        columns: [
                                                            'name',
                                                            'action',
                                                        ]
                                                    "
                                                ></tr>
                                            </table>
                                            <div>
                                                <button
                                                    class="styled-button"
                                                    *objectHasPermission="
                                                        permissionObject;
                                                        action: GridPermissions.Create
                                                    "
                                                    (click)="
                                                        openLocationDialog(
                                                            '',
                                                            group.id
                                                        )
                                                    "
                                                >
                                                    {{
                                                        "Create New Location"
                                                            | translate
                                                    }}
                                                </button>
                                            </div>
                                        </div>
                                    </td>
                                </ng-container>

                                <tr
                                    mat-header-row
                                    *matHeaderRowDef="
                                        displayedColumns.concat(['actions'])
                                    "
                                ></tr>
                                <tr
                                    mat-row
                                    *matRowDef="
                                        let group;
                                        columns: displayedColumns.concat([
                                            'actions',
                                        ])
                                    "
                                    class="element-row"
                                    [class.expanded-row]="isExpanded(group)"
                                ></tr>
                                <tr
                                    mat-row
                                    *matRowDef="
                                        let group;
                                        columns: ['expandedDetail']
                                    "
                                    class="detail-row"
                                    [ngClass]="{
                                        'hidden-row': !isExpanded(group),
                                    }"
                                ></tr>
                            </table>
                        </div>
                        <mat-paginator
                            appBubblePagination
                            class="mat-pagination-custom"
                            [length]="$safeNavigationMigration(dataSource?.count$) | async"
                            [pageSizeOptions]="[5, 10, 20]"
                            [pageSize]="10"
                            showFirstLastButtons
                        ></mat-paginator>
                    </div>
                </div>
            </div>

            <div class="clearfix"></div>
        </section>
    </app-sidebar-layout>
</div>
